const commonReportSx = (backgroundColor: string) => ({
  backgroundColor,
  borderRadius: '7.2px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
});

export const laborReportsSx = commonReportSx('#E0700B');
export const inventoryReportSx = commonReportSx('#0D315E');
export const salesReportSx = commonReportSx('#89CB1F');
export const kitchenReportSx = commonReportSx('#D53964');
export const menuReportsSx = commonReportSx('#4C90E6');
export const favoritesReportsSx = commonReportSx('#EEC226');

export const iconSx = { color: 'white', fontSize: '20px' };
